export const en = {
  // Navigation
  nav: {
    dashboard: 'Dashboard',
    profile: 'Profile',
    signOut: 'Sign Out',
    settings: 'Settings',
  },

  // Dashboard
  dashboard: {
    welcome: 'Welcome back',
    welcomeSubtext: 'Manage your events and connect with friends',
    calendar: 'Calendar',
    createEvent: 'Create Event',
    yourEvents: 'Your Events',
    manageEvents: 'Manage and track all your events',
    searchEvents: 'Search events...',
    filter: {
      all: 'All Events',
      hosting: 'Hosting',
      attending: 'Attending',
    },
    stats: {
      totalEvents: 'Total Events',
      hosting: 'Hosting',
      attending: 'Attending',
    },
    noEvents: 'No events yet',
    noEventsFound: 'No events found',
    noEventsDescription: 'Create your first event to get started and bring people together!',
    noEventsFoundDescription: 'Try adjusting your search or filter criteria.',
    loading: 'Loading your dashboard...',
    syncingProfile: 'Syncing your profile information...',
  },

  // Event Tile
  eventTile: {
    host: 'Host',
    upcoming: 'Upcoming',
    past: 'Past',
    attending: 'attending',
    manageEvent: 'Manage Event',
    daysOfWeek: {
      Sun: 'Sun',
      Mon: 'Mon',
      Tue: 'Tue',
      Wed: 'Wed',
      Thu: 'Thu',
      Fri: 'Fri',
      Sat: 'Sat',
    },
    monthsShort: {
      Jan: 'Jan',
      Feb: 'Feb',
      Mar: 'Mar',
      Apr: 'Apr',
      May: 'May',
      Jun: 'Jun',
      Jul: 'Jul',
      Aug: 'Aug',
      Sep: 'Sep',
      Oct: 'Oct',
      Nov: 'Nov',
      Dec: 'Dec',
    },
  },

  // Calendar
  calendar: {
    upcomingEvents: 'Upcoming Events',
    hosting: 'Hosting',
    attending: 'Attending',
    event: 'event',
    events: 'events',
    more: 'more',
    daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  },

  // Event Dashboard
  event: {
    tasks: 'Tasks',
    expenses: 'Expenses',
    attendees: 'Event Attendees',
    seeWhosComing: "See who's coming to your event",
    shareEvent: 'Share Event',
    locationNotSpecified: 'Location not specified',
    loadingEvent: 'Loading event...',
    loadingProfile: 'Loading your profile...',
    back: 'Back',
    loadingAttendees: 'Loading attendees...',
    personGoing: 'Person Going',
    peopleGoing: 'People Going',
    host: 'Host',
    eventHost: 'Event Host',
    attendee: 'Attendee',
    noAttendeesYet: 'No attendees yet',
    shareEventInvite: 'Share your event link to invite people and see them appear here.',
    pageOf: 'of',
  },

  // Event Data
  eventData: {
    host: 'Host',
    joinEvent: 'Join Event',
    leaveEvent: 'Leave Event',
    editEvent: 'Edit Event',
    deleteEvent: 'Delete Event',
    shareLink: 'Share Link',
    linkCopied: 'Event link copied to clipboard!',
    confirmDelete: 'Are you sure you want to delete this event?',
    deleteWarning: 'This action cannot be undone.',
    cancel: 'Cancel',
    delete: 'Delete',
    youreTheHost: "You're the Host",
    personAttending: 'person attending',
    peopleAttending: 'people attending',
    aboutThisEvent: 'About this event',
    location: 'Location',
    tags: 'Tags',
    eventParticipation: 'Event Participation',
    shareEvent: 'Share Event',
    hostActions: 'Host Actions',
    upcomingEvent: 'Upcoming Event',
    pastEvent: 'Past Event',
    eventStatistics: 'Event Statistics',
    totalAttendees: 'Total Attendees',
    eventStatus: 'Event Status',
    upcoming: 'Upcoming',
    completed: 'Completed',
    timeUntilEvent: 'Time Until Event',
  },

  // Share Event Modal
  shareModal: {
    shareEvent: 'Share Event',
    shareThisEvent: 'Share this event',
    copyLink: 'Copy Link',
    linkCopied: 'Link copied!',
    copyLinkTitle: 'Copy link',
    joinMyEvent: 'Join my event',
    checkOutThisEvent: 'Check out this event',
    email: 'Email',
    whatsapp: 'WhatsApp',
    twitter: 'Twitter',
    facebook: 'Facebook',
  },

  // Edit Event Modal
  editModal: {
    editEvent: 'Edit Event',
    updateEventDetails: 'Update your event details',
    eventName: 'Event Name',
    eventNamePlaceholder: "e.g., Anna's Birthday Party",
    dateTime: 'Date & Time',
    selectDateTime: 'Select date & time',
    location: 'Location',
    locationPlaceholder: 'e.g., 123 Rainbow Lane, City',
    description: 'Description',
    descriptionPlaceholder: 'Tell people what to expect at your event...',
    eventImage: 'Event Image',
    eventPreview: 'Event preview',
    clickToUpload: 'Click to upload event image',
    updateEvent: 'Update Event',
    updatingEvent: 'Updating Event...',
    required: '*',
  },

  // Delete Event Modal
  deleteModal: {
    deleteEvent: 'Delete Event',
    cannotBeUndone: 'This action cannot be undone',
    deleteEventTitle: 'Delete "{title}"?',
    confirmDelete: 'Are you sure you want to delete this event?',
    dataWillBeRemoved: 'All event data, tasks, and expenses will be permanently removed.',
    friendsWillBeSad: 'Your friends will be sad 😔',
    cancel: 'Cancel',
    deleting: 'Deleting...',
    errorDeleting: 'Error deleting event.',
  },

  // Create Event Form
  createEvent: {
    title: 'Create New Event',
    subtitle: 'Bring people together',
    hostEvent: 'Host Event',
    eventTitle: 'Event Title',
    eventTitlePlaceholder: 'Enter event title',
    eventName: 'Event Name',
    eventNamePlaceholder: "e.g., Anna's Birthday Party",
    description: 'Description',
    descriptionPlaceholder: 'Describe your event',
    descriptionPlaceholderLong: 'Tell people what to expect at your event...',
    location: 'Location',
    locationPlaceholder: 'Where is your event?',
    locationPlaceholderLong: 'e.g., 123 Rainbow Lane, City',
    date: 'Date',
    time: 'Time',
    dateTime: 'Date & Time',
    selectDateTime: 'Select date & time',
    eventImage: 'Event Image',
    uploadImage: 'Upload Image',
    clickToUpload: 'Click to upload event image',
    browseFiles: 'browse',
    dragAndDrop: 'Drag and drop an image here, or',
    imageRequirements: 'JPG, PNG or GIF (Max 5MB)',
    cancel: 'Cancel',
    create: 'Create Event',
    creating: 'Creating...',
    creatingEvent: 'Creating Event...',
    eventCreatedSuccess: 'Event created successfully!',
    requiredField: '*',
    userIdentificationError: 'Unable to identify user. Please refresh the page and try again.',
  },

  // Expenses
  expenses: {
    title: 'Event Expenses',
    addExpense: 'Add Expense',
    description: 'Description',
    amount: 'Amount',
    paidBy: 'Paid by',
    actions: 'Actions',
    noExpenses: 'No expenses yet',
    noExpensesDescription: 'Start tracking expenses for this event',
    paymentBalance: 'Payment Balance',
    totalExpenses: 'Total Expenses',
    perPerson: 'Per Person',
    youOwe: 'You owe',
    owesYou: 'owes you',
    settledUp: 'Settled up!',
    paid: 'Paid',
    balance: 'Balance',
    suggestedPayments: 'Suggested Payments',
    pays: 'pays',
    descriptionPlaceholder: 'What was this expense for?',
    amountPlaceholder: 'Amount',
    selectPayer: 'Select who paid',
    trackAndManage: 'Track and manage event costs',
    averageExpense: 'Average Expense',
    totalItems: 'Total Items',
    expenseHistory: 'Expense History',
    spendingBreakdown: 'Spending Breakdown',
    settlementDescription: 'Who owes money and who is owed',
    splitEqually: 'Split equally among',
    attendee: 'attendee',
    attendees: 'attendees',
    everyonePaid: 'Everyone has paid their fair share',
    to: 'to',
    settleBalancesInstruction: 'To settle all balances, make these payments:',
  },

  // Settings
  settings: {
    title: 'Settings',
    currency: 'Currency',
    language: 'Language',
    theme: 'Theme',
    lightTheme: 'Light',
    darkTheme: 'Dark',
    saveChanges: 'Save Changes',
    cancel: 'Cancel',
    currencies: {
      usd: 'US Dollar',
      eur: 'Euro',
      gbp: 'British Pound',
    },
    languages: {
      english: 'English',
      spanish: 'Español',
      french: 'Français',
    },
  },

  // Profile
  profile: {
    title: 'Profile Settings',
    subtitle: 'Manage your account information and preferences',
    personalInfo: 'Personal Information',
    security: 'Security',
    fullName: 'Full Name',
    phoneNumber: 'Phone Number',
    emailAddress: 'Email Address',
    profilePicture: 'Profile Picture',
    uploadPhoto: 'Upload Photo',
    uploading: 'Uploading...',
    photoInfo: 'JPG, PNG or GIF. Max size of 5MB.',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    passwordStrength: 'Password Strength',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    profileUpdated: 'Profile updated successfully!',
    namePlaceholder: 'Enter your full name',
    phonePlaceholder: 'Enter your phone number',
    emailPlaceholder: 'Enter your email address',
    currentPasswordPlaceholder: 'Enter current password to change',
    newPasswordPlaceholder: 'Enter new password',
    confirmPasswordPlaceholder: 'Confirm new password',
    backToDashboard: 'Back to Dashboard',
    loadingProfile: 'Loading profile...',
    userDataNotLoaded: 'User data not loaded. Please refresh the page.',
    passwordsDoNotMatch: 'New passwords do not match',
    passwordTooWeak: 'Password is too weak. Please use a stronger password.',
    noChangesToSave: 'No changes to save.',
    emailAlreadyInUse: 'This email is already in use by another account.',
    updateError: 'Failed to update profile. Please try again.',
    generalError: 'An error occurred while updating your profile.',
    uploadImageError: 'Failed to upload image',
    updateProfilePicError: 'Failed to update profile picture',
    retryUpload: 'Failed to upload image. Please try again.',
  },

  // Tasks/Todos
  tasks: {
    title: 'Event Tasks',
    subtitle: 'Organize and track tasks for your event',
    addNewTask: 'Add new task',
    pendingCompleted: '{pending} pending, {completed} completed',
    loadingTasks: 'Loading tasks...',
    enterTaskDescription: 'Enter task description...',
    pendingTasks: 'Pending Tasks',
    completedTasks: 'Completed Tasks',
    noPendingTasks: 'No pending tasks',
    noCompletedTasks: 'No completed tasks yet',
    progressOverview: 'Progress Overview',
    tasksCompleted: '{completed} of {total} tasks completed',
    remaining: '{remaining} remaining',
    completed: 'Completed',
    markAsIncomplete: 'Mark as incomplete',
  },

  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    refresh: 'Refresh',
    add: 'Add',
    remove: 'Remove',
    yes: 'Yes',
    no: 'No',
    altText: {
      profile: 'Profile',
      eventPreview: 'Event preview',
    },
  },
};